interface HeroEditorProps {
  data: {
    title: string;
    subtitle: string;
    cta_text: string;
    cta_link: string;
    background_image: string;
  };
  onChange: (data: any) => void;
}

export default function HeroEditor({ data, onChange }: HeroEditorProps) {
  const handleChange = (field: string, value: string) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  return (
    <div className="space-y-6">
      <div className="border-b pb-4">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <i className="ri-home-line text-blue-600"></i>
          Editar Hero Section
        </h2>
        <p className="text-gray-600 mt-1">Sección principal de la página de inicio</p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Título Principal
          </label>
          <input
            type="text"
            value={data.title}
            onChange={(e) => handleChange('title', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: Transformamos tu Negocio Digital"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Subtítulo
          </label>
          <textarea
            value={data.subtitle}
            onChange={(e) => handleChange('subtitle', e.target.value)}
            rows={3}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: Agencia de Marketing Digital..."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Texto del Botón
            </label>
            <input
              type="text"
              value={data.cta_text}
              onChange={(e) => handleChange('cta_text', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Ej: Cotizar Ahora"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Enlace del Botón
            </label>
            <input
              type="text"
              value={data.cta_link}
              onChange={(e) => handleChange('cta_link', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Ej: #contact"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL de Imagen de Fondo (opcional)
          </label>
          <input
            type="text"
            value={data.background_image}
            onChange={(e) => handleChange('background_image', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="https://ejemplo.com/imagen.jpg"
          />
          <p className="text-sm text-gray-500 mt-1">
            Deja vacío para usar el fondo por defecto
          </p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
          <i className="ri-information-line"></i>
          Vista Previa
        </h3>
        <div className="bg-white rounded-lg p-6 border border-blue-100">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{data.title}</h1>
          <p className="text-gray-600 mb-4">{data.subtitle}</p>
          <button className="bg-blue-600 text-white px-6 py-2 rounded-lg">
            {data.cta_text}
          </button>
        </div>
      </div>
    </div>
  );
}
